function s(t,r){let e=!1;return function(...a){e||(t.apply(this,a),e=!0,setTimeout(()=>{e=!1;},r));}}

export { s as a };
